require 'jquery-ujs'
BackboneDirty = require 'backbone.dirty'

class Backbone.Enhanced.Model extends BackboneDirty
  # Create model attribute getter/setter property.
  @attribute = (attr) ->
      Object.defineProperty @prototype, attr,
          get: -> @get attr
          set: (value) ->
              attrs = {}
              attrs[attr] = value
              @set attrs

  save: (key, val, options) ->
    @_beforeSave(key, val, options)
    Backbone.Model.prototype.save.call(this, key, val, options)

  _beforeSave: (key, val, options) ->
    @trigger('beforeSave')

  # credit to https://gist.github.com/gcollazo/1240683 for this sync method below
  # This is needed to send CSRF and devise authentication knowledge back to the server
  sync: (method, model, options) ->
    csrfSafeMethod = (method) ->
        # these HTTP methods do not require CSRF protection
        /^(GET|HEAD|OPTIONS|TRACE)$/.test method

    options.beforeSend = (xhr, settings) ->
      if !csrfSafeMethod(settings.type) and !@crossDomain
        content = document.querySelector('meta[name="csrf-token"]').content
        xhr.setRequestHeader 'x-csrf-token', content
      return

    Backbone.sync method, model, options

module.exports = Backbone.Enhanced.Model